import { useState, useEffect } from "react";
import { FileDown } from "lucide-react";
import { generateDossier } from "../pdf";

export const HudNav = ({ t, lang, setLang, pdfLabel = "Dossier PDF", pdfBusy = "…", galleryLabel = "Gallery" }) => {
  const [scrolled, setScrolled] = useState(false);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", fn);
    return () => window.removeEventListener("scroll", fn);
  }, []);
  const base = window.location.pathname === "/" ? "" : "/";
  const links = [
    ["#tech", t.tech], ["#lines", t.lines], ["#alarm", t.alarm],
    ["#verification", t.verification], ["#lifecycle", t.lifecycle],
  ];
  const download = async () => {
    setBusy(true);
    try {
      await generateDossier(lang);
    } finally {
      setBusy(false);
    }
  };
  return (
    <header data-testid="hud-nav" className={`fixed top-0 inset-x-0 z-50 border-b transition-colors duration-500 ${scrolled ? "bg-[#050505]/90 backdrop-blur-md border-[#272A2E]" : "bg-transparent border-transparent"}`}>
      <div className="max-w-[1600px] mx-auto px-6 md:px-10 h-16 flex items-center justify-between">
        <a href="/" data-testid="nav-logo" className="font-display font-black tracking-tighter text-white text-lg uppercase">
          Shadow<span className="text-[#FF2A00]">Shield</span>
        </a>
        <nav className="hidden lg:flex items-center gap-8">
          {links.map(([href, label]) => (
            <a key={href} href={`${base}${href}`} data-testid={`nav-link-${href.slice(1)}`} className="text-xs font-mono tracking-[0.15em] uppercase text-[#8A8F98] hover:text-white transition-colors duration-300">{label}</a>
          ))}
          <a href="/galleria" data-testid="nav-link-gallery" className="text-xs font-mono tracking-[0.15em] uppercase text-[#8A8F98] hover:text-white transition-colors duration-300">{galleryLabel}</a>
        </nav>
        <div className="flex items-center gap-6">
          <span className="hidden md:block text-[10px] font-mono tracking-[0.2em] text-[#8A8F98]">{t.coords}</span>
          <button onClick={download} disabled={busy} data-testid="nav-pdf"
            className="hidden sm:flex items-center gap-2 text-xs font-mono tracking-[0.15em] uppercase text-[#8A8F98] hover:text-[#FF2A00] transition-colors duration-300 disabled:opacity-50">
            <FileDown size={14} /> {busy ? pdfBusy : pdfLabel}
          </button>
          <div data-testid="lang-toggle" className="flex border border-[#272A2E]">
            {["it", "en", "ar"].map((l) => (
              <button key={l} data-testid={`lang-${l}`} onClick={() => setLang(l)}
                className={`px-3 py-1.5 text-xs font-mono uppercase tracking-widest transition-colors duration-300 ${lang === l ? "bg-[#FF2A00] text-black" : "text-[#8A8F98] hover:text-white"}`}>
                {l}
              </button>
            ))}
          </div>
          <a href={`${base}#contact`} data-testid="nav-cta" className="hidden sm:block text-xs font-mono tracking-[0.15em] uppercase border border-[#FF2A00] text-[#FF2A00] px-4 py-2 hover:bg-[#FF2A00] hover:text-black transition-colors duration-300">
            {t.cta}
          </a>
        </div>
      </div>
    </header>
  );
};
